module.exports = {
	payment_methods: [
		{ id: "visa_master" },
		{ id: "union_pay" },
		{ id: "alipay" },
		{ id: "wechat_pay" },
		{ id: "fps" }
	]
};
